export const isMacOS =
  typeof navigator !== 'undefined' &&
  ((navigator as any).userAgentData?.platform === 'macOS' ||
    /Mac|iPhone|iPad/.test(navigator.userAgent));
